module.exports = __webpack_public_path__ + "img/logo-lfb-couleur.ec62b40b.jpg";